var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('resource-view',{attrs:{"model":"Employee","slug":"sysop_employee","role":"sysop"}})
}
var staticRenderFns = []

export { render, staticRenderFns }